import { Building2 } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DepartmentStatusRow } from './DepartmentStatusRow';
import { EmptyState } from '@/components/shared/EmptyState';
import { api } from '@/lib/api';
import type { DepartmentStatus } from '@/types/api';

export function DepartmentStatusPanel() {
  const { data: departments, isLoading } = useQuery({
    queryKey: ['departments'],
    queryFn: () => api.departments.list(),
    refetchInterval: 30_000,
  });

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-sm font-semibold">
          <Building2 className="h-4 w-4 text-teal" />
          Departments
        </CardTitle>
      </CardHeader>
      <CardContent className="px-3 pb-4">
        {isLoading ? (
          <div className="space-y-2">
            {Array.from({ length: 4 }, (_, i) => (
              <div
                key={i}
                className="h-12 animate-pulse rounded-md bg-muted"
              />
            ))}
          </div>
        ) : !departments || departments.length === 0 ? (
          <EmptyState
            icon={Building2}
            title="No departments"
            description="Departments will appear once configured."
          />
        ) : (
          <div className="space-y-1">
            {(departments as DepartmentStatus[]).map((dept) => (
              <DepartmentStatusRow key={dept.department} department={dept} />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
